import { Typography } from '@mui/material'
import {
  getPanelHistory,
  useHistoryCustomBack,
  useNavigate,
  usePanelHistoryTop,
} from 'weblite-router'
import { VisibilityHandler } from '$scenes/components/visibility-handler'
import { StaticPanelWappId } from '$logic/wapp-panels'
import { StaticWappPanel } from '$comp/static-wapp-panel'
import { HomePanel } from '$scenes/router-panels/router-panels'
import { AppBarBackTitle } from '$common/app-bar/app-bar-back-title'
import { t } from '$i18n'
import { switchToRoomList } from '$logic/router'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { usePreventPreLoad } from '$hooks/use-prevent-preload'

export function Mavakeb() {
  const navigate = useNavigate()

  const homePanelState = usePanelHistoryTop('home')?.state
  const isTop = homePanelState?.tab === 'mavakeb'

  const preventPreLoad = usePreventPreLoad(isTop)

  useHistoryCustomBack(
    () => {
      const panelHistory = getPanelHistory('mavakeb')
      if (panelHistory.length > 1) navigate(-1)
      else
        HomePanel.navigate('home', {
          replace: true,
          absolute: true,
          data: { tab: 'roomList' },
        })
    },
    [],
    isTop,
  )

  if (preventPreLoad) return null
  return (
    <VisibilityHandler zIndex={1} considerIOSNotch>
      <PageWithAppBar
        appBar={
          <AppBarBackTitle
            title={
              <Typography variant="subtitle1" color="neutral800">
                {t('navigationBar.stations')}
              </Typography>
            }
            onBack={switchToRoomList}
          />
        }
      >
        <StaticWappPanel
          panelName="mavakeb"
          wappId={StaticPanelWappId.MAVAKEB}
          input={{ mode: 'CHANNEL' }}
        />
      </PageWithAppBar>
      {/*<Box sx={{ height: `calc(100% - ${NAVIGATION_BAR_HEIGHT}px)` }}>*/}
      {/*  <StaticWappPanel*/}
      {/*    panelName="mavakeb"*/}
      {/*    wappId={StaticPanelWappId.MAVAKEB}*/}
      {/*    input={{ mode: 'CHANNEL' }}*/}
      {/*  />*/}
      {/*</Box>*/}
    </VisibilityHandler>
  )
}
